import React, { Component } from 'react';
import SubModuleItem from './SubModuleItem';
import item from './SubModuleDetail';


let card = '';
var subModule;


class SubModule extends Component {

  constructor() {
    super();
    this.state = {
      subModuleList: item,
      filterModule : item,
    }
  }

  updateState(text){
    subModule = [text]; 
    card =this.setState({  filterModule: this.state.subModuleList.filter(module => subModule
      .map(val => module.category.indexOf(val))
      .map(val => (val > -1 ? true : false))
      .reduce((acc, cum) => acc && cum)  
      )});     
  }

  componentDidMount(){
    this.updateState("BCM");
  }

  render () {
    let ModuleSelect= this.state.filterModule.map(module => {
      return (
        <div key={module.id}>
          <SubModuleItem   module={module}/>
        </div>
      )})

       return (      
           <div>
            {ModuleSelect}
           </div>
         )
   }
}

export default SubModule;
